import { Button } from '@/components/ui/button';
import { SUPPORTED_LOCALES } from '@/i18n/i18n';
import { useTranslation } from 'react-i18next';

interface LanguageFiltersProps {
  filterLanguages: string[];
  onToggleLanguage: (lang: string) => void;
}

export const LanguageFilters = ({
  filterLanguages,
  onToggleLanguage,
}: LanguageFiltersProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-wrap items-center gap-2">
      {SUPPORTED_LOCALES.map((locale) => {
        const isOn = filterLanguages.includes(locale);
        return (
          <Button
            key={locale}
            variant={isOn ? 'default' : 'outline'}
            size="sm"
            className="shrink-0"
            onClick={() => onToggleLanguage(locale)}>
            {t(`home:languages.${locale}`, locale)}
          </Button>
        );
      })}
    </div>
  );
};
